module.exports = __webpack_public_path__ + "/login_ui/img/mp-c7d80099776ec06f174f6f9e22553d00.svg";